/* Feather Footwear — interactions (drawer, quick view, cart, filters) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var lastFocus = null;

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function openLayer(el) { lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); var f = el.querySelector('[data-ff-focus]') || el.querySelector('button,a'); if (f) setTimeout(function () { f.focus(); }, 60); }
  function closeLayer(el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false); if (lastFocus) lastFocus.focus(); }

  /* ---------- cart count ---------- */
  function setCount(n) {
    $$('[data-ff-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); }); return r.json(); })
      .then(refreshCount);
  }

  /* ---------- menu drawer ---------- */
  var drawer = $('#ff-drawer');
  if (drawer) {
    $$('[data-ff-open-menu]').forEach(function (b) { b.addEventListener('click', function () { openLayer(drawer); }); });
    $$('[data-ff-close-menu]', drawer).forEach(function (b) { b.addEventListener('click', function () { closeLayer(drawer); }); });
  }

  /* ---------- size picker (shared by quick view + product page) ---------- */
  function buildSizes(wrap, variants, onPick) {
    wrap.innerHTML = '';
    wrap.style.gridTemplateColumns = 'repeat(' + Math.min(variants.length, 7) + ',minmax(0,1fr))';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ff-size'; b.textContent = v.title;
      b.setAttribute('aria-pressed', 'false');
      if (!v.available) { b.disabled = true; b.setAttribute('aria-label', 'Size ' + v.title + ', sold out'); }
      else { b.setAttribute('aria-label', 'Size ' + v.title); }
      b.addEventListener('click', function () {
        $$('.ff-size', wrap).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        onPick(v);
      });
      wrap.appendChild(b);
    });
  }
  function lowText(v) {
    if (v && v.tracked && v.qty > 0 && v.qty <= 3) return 'Only ' + v.qty + ' left in size ' + v.title + '. Order soon.';
    return '';
  }

  /* ---------- swipe photos + dots ---------- */
  function slider(track, dots) {
    if (!track || !dots) return;
    var n = track.children.length;
    dots.innerHTML = '';
    dots.hidden = n < 2;
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
    var paint = function () {
      var kids = track.children, x = track.scrollLeft, k = 0, best = Infinity;
      for (var j = 0; j < kids.length; j++) { var d = Math.abs(kids[j].offsetLeft - kids[0].offsetLeft - x); if (d < best) { best = d; k = j; } }
      $$('span', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    };
    if (!track._ffSlider) {
      track.addEventListener('scroll', function () { track._ffPaint(); }, { passive: true });
      track._ffSlider = true;
    }
    track._ffPaint = paint;
    paint();
  }

  /* ---------- quick view ---------- */
  var qv = $('#ff-qv');
  if (qv) {
    var qvState = { variant: null, data: null };
    var cta = $('[data-qv-add]', qv);
    function setCta() {
      if (!qvState.variant) { cta.disabled = true; cta.textContent = 'Select a size'; return; }
      cta.disabled = false; cta.textContent = 'Add to cart · ' + qvState.variant.price;
      cta.className = 'ff-btn ff-btn--terra ff-btn--block';
    }
    function openQv(data) {
      qvState.data = data; qvState.variant = null;
      var track = $('[data-qv-track]', qv);
      var pics = (data.images && data.images.length) ? data.images : [data.image];
      track.innerHTML = pics.map(function (src, i) { return '<img src="' + src + '" alt="' + (i === 0 ? data.title.replace(/"/g, '&quot;') : '') + '" width="1000" height="1250"' + (i ? ' loading="lazy"' : '') + '>'; }).join('');
      track.scrollLeft = 0;
      slider(track, $('[data-qv-dots]', qv));
      $('[data-qv-prev]', qv).hidden = pics.length < 2;
      $('[data-qv-next]', qv).hidden = pics.length < 2;
      $('[data-qv-title]', qv).textContent = data.title;
      $('[data-qv-price]', qv).textContent = data.price;
      $('[data-qv-compare]', qv).textContent = data.compare || '';
      $('[data-qv-save]', qv).textContent = data.save ? 'You save ' + data.save : '';
      $('[data-qv-badge]', qv).textContent = data.off ? '−' + data.off + '%' : '';
      $('[data-qv-badge]', qv).hidden = !data.off;
      $('[data-qv-link]', qv).href = data.url;
      $('[data-qv-low]', qv).textContent = '';
      $('[data-qv-size-label]', qv).textContent = 'choose one';
      buildSizes($('[data-qv-sizes]', qv), data.variants, function (v) {
        qvState.variant = v; $('[data-qv-size-label]', qv).textContent = v.title;
        $('[data-qv-low]', qv).textContent = lowText(v); setCta();
      });
      if (data.variants.length === 1 && data.variants[0].available) { $('.ff-size', qv).click(); }
      setCta();
      qv.setAttribute('aria-label', data.title);
      openLayer(qv);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ff-qv]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-ff-card]');
      var json = card && $('script[data-ff-product]', card);
      if (json) openQv(JSON.parse(json.textContent));
    });
    $$('[data-qv-close]', qv).forEach(function (b) { b.addEventListener('click', function () { closeLayer(qv); }); });
    var qvTrack = $('[data-qv-track]', qv);
    $('[data-qv-prev]', qv).addEventListener('click', function () { qvTrack.scrollBy({ left: -qvTrack.clientWidth, behavior: 'smooth' }); });
    $('[data-qv-next]', qv).addEventListener('click', function () { qvTrack.scrollBy({ left: qvTrack.clientWidth, behavior: 'smooth' }); });
    cta.addEventListener('click', function () {
      if (!qvState.variant) return;
      if (cta.dataset.added === '1') { window.location.href = '/cart'; return; }
      cta.disabled = true; cta.textContent = 'Adding…';
      addToCart(qvState.variant.id, 1).then(function () {
        cta.disabled = false; cta.dataset.added = '1';
        cta.className = 'ff-btn ff-btn--green ff-btn--block';
        cta.textContent = 'Added ✓  View cart';
        setTimeout(function () { cta.dataset.added = ''; }, 6000);
      }).catch(function (err) { cta.disabled = false; cta.textContent = err.message; });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.ff-qv.is-open,.ff-drawer.is-open').forEach(closeLayer);
  });

  /* ---------- product page ---------- */
  var pdp = $('[data-ff-pdp]');
  if (pdp) {
    var pdata = JSON.parse($('script[data-ff-product]', pdp).textContent);
    slider($('.ff-gallery', pdp), $('[data-ff-dots]', pdp));
    var input = $('input[name="id"]', pdp);
    var addBtn = $('[data-pdp-add]', pdp);
    var sticky = $('[data-ff-sticky]');
    var stickyBtn = sticky && $('button', sticky);
    var chosen = null;
    function paint() {
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        if (!chosen) { b.disabled = true; b.textContent = 'Select a size'; }
        else { b.disabled = false; b.textContent = 'Add to cart · ' + chosen.price; }
      });
    }
    buildSizes($('[data-pdp-sizes]', pdp), pdata.variants, function (v) {
      chosen = v; input.value = v.id;
      $('[data-pdp-size-label]', pdp).textContent = v.title;
      $('[data-pdp-low]', pdp).textContent = lowText(v);
      paint();
    });
    if (pdata.variants.length === 1 && pdata.variants[0].available) { $('.ff-size', pdp).click(); }
    paint();
    function doAdd(btn) {
      if (!chosen) { $('[data-pdp-sizes]', pdp).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(chosen.id, 1).then(function () {
        [addBtn, stickyBtn].forEach(function (b) { if (b) { b.disabled = false; b.textContent = 'Added ✓  Go to cart'; b.onclick = function (ev) { ev.preventDefault(); window.location.href = '/cart'; }; } });
      }).catch(function (err) { btn.disabled = false; btn.textContent = err.message; });
    }
    addBtn.addEventListener('click', function (e) { e.preventDefault(); if (addBtn.onclick) return; doAdd(addBtn); });
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { if (stickyBtn.onclick) return; doAdd(stickyBtn); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(addBtn);
      }
    }
  }

  /* ---------- collection filters (instant, no reload) ---------- */
  var col = $('[data-ff-collection]');
  if (col) {
    var cards = $$('[data-ff-card]', col);
    var grid = $('[data-ff-grid]', col);
    var st = { type: 'all', max: Infinity, sort: 'featured' };
    var q = new URLSearchParams(location.search);
    if (q.get('type')) st.type = q.get('type');
    if (q.get('under')) st.max = parseFloat(q.get('under'));
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (st.type === 'all' || c.dataset.type === st.type) && parseFloat(c.dataset.price) < st.max;
        c.hidden = !ok; if (ok) shown++;
      });
      var sorted = cards.slice();
      if (st.sort === 'low') sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (st.sort === 'off') sorted.sort(function (a, b) { return b.dataset.off - a.dataset.off; });
      else sorted.sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      sorted.forEach(function (c) { grid.appendChild(c); });
      $('[data-ff-shown]', col).textContent = shown + (shown === 1 ? ' style' : ' styles');
      $('[data-ff-empty]', col).hidden = shown > 0;
      $$('[data-ff-tab]', col).forEach(function (t) { var on = t.dataset.ffTab === st.type; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      $$('[data-ff-under]', col).forEach(function (t) { var v = t.dataset.ffUnder === 'any' ? Infinity : parseFloat(t.dataset.ffUnder); var on = v === st.max; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on); });
      var title = $('[data-ff-title]', col);
      if (title) title.textContent = st.type === 'loafer' ? 'Loafers' : st.type === 'sandal' ? 'Breeze Sandals' : title.dataset.default;
    }
    $$('[data-ff-tab]', col).forEach(function (t) { t.addEventListener('click', function () { st.type = t.dataset.ffTab; apply(); }); });
    $$('[data-ff-under]', col).forEach(function (t) { t.addEventListener('click', function () { st.max = t.dataset.ffUnder === 'any' ? Infinity : parseFloat(t.dataset.ffUnder); apply(); }); });
    var sortSel = $('[data-ff-sort]', col);
    if (sortSel) sortSel.addEventListener('change', function () { st.sort = sortSel.value; apply(); });
    apply();
  }

  /* ---------- cart page quantity ---------- */
  $$('[data-ff-change]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.qty, 10) }) })
        .then(function () { window.location.reload(); });
    });
  });
  /* ---------- search bar (opens under the header, results inline) ---------- */
  var sbar = $('#ff-searchbar');
  if (sbar) {
    var sInput = $('[data-ff-search-input]', sbar);
    var sOut = $('[data-ff-search-results]', sbar);
    var sTimer = null, sSeq = 0;
    var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var rs = function (p) { var n = parseFloat(p); if (isNaN(n)) return ''; return 'Rs.' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); };
    var openBar = function () {
      if (drawer && drawer.classList.contains('is-open')) closeLayer(drawer);
      sbar.hidden = false;
      $$('[data-ff-search-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { sInput.focus(); }, 30);
    };
    var closeBar = function () {
      sbar.hidden = true; sOut.innerHTML = ''; sInput.value = '';
      $$('[data-ff-search-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    };
    var runSearch = function () {
      var term = sInput.value.trim();
      if (term.length < 2) { sOut.innerHTML = ''; return; }
      var my = ++sSeq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (my !== sSeq) return;
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!ps.length) { sOut.innerHTML = '<div class="ff-snote">No styles found for "' + esc(term) + '". Try a colour like black or beige.</div>'; return; }
          sOut.innerHTML = ps.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            return '<a class="ff-sres" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') +
              '<div><b>' + esc(String(p.title).replace("Women's ", '')) + '</b><span>' + rs(p.price) + (p.available === false ? ' · Sold out' : '') + '</span></div></a>';
          }).join('');
        }).catch(function () {});
    };
    $$('[data-ff-search-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); if (sbar.hidden) openBar(); else closeBar(); });
    });
    $('[data-ff-search-close]', sbar).addEventListener('click', closeBar);
    sInput.addEventListener('input', function () { clearTimeout(sTimer); sTimer = setTimeout(runSearch, 200); });
    $('[data-ff-search-form]', sbar).addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(sTimer); runSearch(); sInput.blur(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sbar.hidden) closeBar(); });
  }
})();
